import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class FilingFormTypeApi<FilingFormType> extends BaseAPI {
  // constructor() {}

  public getFilingFormTypeById: (id: number) => Promise<FilingFormType> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/filingFormType/${id}`)).data.output;
  }

  public getFilingFormTypes: () => Promise<FilingFormType> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/filingFormType/`)).data.output;
  };
}

export const filingFormTypeAPI = new FilingFormTypeApi();
